import SingleOfferTemplate from '../../component/template/SingleOfferTemplate'
import Webview from '../../component/native/visible/Webview'
// import Message from '../../Message'
// import App from '../../App'

export default class AtmosphereTemplate extends SingleOfferTemplate {
  constructor(props = {}) {
    super(props)

    this.tpl = null
  }


  async adShowed(data) {
    super.adShowed()
  }

  initComponents() {
    super.initComponents()

    // 初始化单offer tpl
    this.tpl = new Webview()
    let tplURL = this.campaign.rv.template_url
    tplURL += '&createByAtmosphere=1'
    Webview.getLoadCampaignParams(tplURL, [this.campaign], this.unit.id, this.unit.setting)
        .then(loadParams=>{
          console.log('获取到load campaign参数：', loadParams)
            this.tpl.load(loadParams)
        })
  }

  /**
   * 初始化插槽
   */
  initSlots(){
    super.initSlots()
    this.slotIn('slot_1', this.tpl)
  }

  /**
   * 销毁组件
   */
  destory() {
    super.destory()
    this.tpl && this.tpl.destory()
  }

  /**
   * 子类需要重写该方法，以判断模板的是否成功加载
   * @returns {Promise}
   */
  _isLoadFinish(){
    const promise = Promise.all([
      super._isLoadFinish(),
      this.tpl.whenCampaignReady(),
    ])
    promise.then(() => {
      console.log('tpl load 成功')
    }).catch(e=>{
      console.log('tpl load 失败', e)
    })
    return promise
  }
}